import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderFinishedCargoOrdersCountParams from "./order-finished-cargo-orders-count-params";

const useOrderFinishedCargoOrdersCount = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<number | null>(null);

  const load = async (
    params: OrderFinishedCargoOrdersCountParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const orderFinishedCargoOrdersCount =
        await orderService.getFinishedCargoOrdersCount(params, signal);

      setData(orderFinishedCargoOrdersCount);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderFinishedCargoOrdersCount;
